import React, { useState, Fragment, useEffect } from "react";
// import QRScan from "qrscan";
import QrReader from "react-qr-reader";
import Bunexe_service from "../Bunexe_service";

import { toast } from "react-toastify";

const VerifDiplome = () => {
  const [watching, setWatching] = useState(false);
  const [val, setVal] = useState("");
  const [result, setResult] = useState("");
  const [info, setInfo] = useState([]);
  let url_ = Bunexe_service.url;

  const onFind = (value) => {
    setVal(value);
    setWatching(false);
    //this.setState({ value, watching: false })
  };

  const handleScan = (data) => {
    if (data) {
      setResult(data);
      setWatching(false);
    }
  };
  const handleError = (err) => {
    toast.error("Information non - trouvée, Veuiller Scanner le QRCode" + err, {
      position: toast.POSITION.TOP_RIGHT,
    });
    console.error(err);
  };

  const Rechercher = async () => {
    // let url_ = "http://localhost:8086/api";

    //dossier/an_section/identifiant/20180100000987O
    if (result) {
      try {
        fetch(url_ + `/dossier/an_section/identifiant/${result}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.data.length > 0) {
              console.log(data.data[0]);
              setInfo(data.data);
            } else
              toast.error(
                "Information non - trouvée, Veuiller Scanner le QRCode",
                {
                  position: toast.POSITION.TOP_RIGHT,
                }
              );
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.error(
        "Information non - trouvée, Veuiller consulter le numéro d'ordre du candidat",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
  };
  useEffect(() => {
    Rechercher();
  }, [result]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4 offset-md-4 mt-4">
          {watching && info.length == 0 && result === "" ? (
            <QrReader
              delay={300}
              onError={handleError}
              onScan={handleScan}
              style={{ width: "450px", height: "450px" }}
            />
          ) : (
            <>
              <Fragment>
                {info.length == 0 && (
                  <button
                    className="btn btn-primary"
                    onClick={() => setWatching(true)}
                  >
                    Scanner pour verifier les informations sur un diplôme ou un
                    relevé
                  </button>
                )}
                {result && info.length == 0 && <h4>value: {result}</h4>}
              </Fragment>
            </>
          )}
          {info.length > 0 && (
            <>
              <p>
                <button
                  className="btn btn-warning"
                  onClick={() => {
                    setWatching(true);
                    setInfo([]);
                    setResult("");
                  }}
                >
                  Reinitialiser
                </button>
              </p>

              <div className="card">
                <div className="card-header">
                  <h3>{`Information pour le code  ${result}`}</h3>
                </div>
                <div className="card-body">
                  <h3 className="display-6">
                    {`Nom : ${info[0].nom}  ${info[0].prenom} , Admis : ${
                      info[0].Admis === "O" ? "Oui" : "Non"
                    }`}
                  </h3>

                  <h3 className="display-6">{`Moyenne : ${parseFloat(
                    info[0].Moy
                  ).toFixed(2)}`}</h3>
                  <h3 className="display-6">{`Notes : ${
                    info[0].NotesExtraOrdinaire != ""
                      ? info[0].NotesExtraOrdinaire
                      : info[0].NotesOrdinaire
                  } sur ${info[0].TotCoef}`}</h3>
                </div>
                <div className="card-footer"></div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* <button onClick={() => setWatching(false)}>Reset</button> */}
    </div>
  );
  //     <Fragment>
  //       <h1>QRScan Demo</h1>
  //       {watching ? (
  //         <QRScan onFind={onFind} />
  //       ) : (
  //         <Fragment>
  //           <button onClick={() => setWatching(true)}>Scan</button>
  //           <h4>value: {val}</h4>
  //         </Fragment>
  //       )}
  //     </Fragment>
  //   );
};

export default VerifDiplome;
